import permissions from '@/constants/permissions'

const GuardianConsent = () => import('@/views/document/GuardianConsent.vue')
export default {
  path: 'zgoda-rodzica-opiekuna',
  name: 'GuardianConsent',
  component: GuardianConsent,
  meta: {
    requireAuth: true,
    permission: [permissions.documentView, permissions.assignedDocumentView]
  }
}
